import script from "./base-tooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-tooltip.vue?vue&type=script&setup=true&lang=ts"

import "./base-tooltip.vue?vue&type=style&index=0&id=ac907db8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac907db8"]])

export default __exports__